import { z } from 'zod';
export const customerDatabaseConfigSchema = z.object({
    id: z.string().min(1, 'ID is required'),
    version: z.string().min(1, 'Version is required'),
    host: z.string().min(1, 'Host is required'),
    port: z.number().min(1, 'Port is required'),
    databaseName: z.string().min(1, 'Database Name is required'),
    cubeApiUrl: z.union([z.string().url(), z.literal('')]).nullish(),
});
export const customerDataSourceConfigSchema = z.object({
    id: z.string().min(1, 'ID is required'),
    organizationName: z.string().min(1, 'Organization is required'),
    currentVersion: z.string().min(1, 'Current Version is required'),
    isMainIntrospectionDB: z.boolean().optional(),
    customerDatabases: z.array(customerDatabaseConfigSchema),
});
export const subgraphConfigSchema = z.object({
    id: z.string().min(1, 'ID is required'),
    subgraphName: z.string().min(1, 'Subgraph Name is required'),
    path: z.string().min(1, 'Path is required'),
    customerDataSources: z.array(customerDataSourceConfigSchema),
});
export const servedSubgraphConfigSchema = subgraphConfigSchema.extend({
    fallbackSmrtVersion: z.string().optional(),
    fallbackSmrtIri: z.string().optional(),
});
export const customerDataApiConfigSchema = z.object({
    id: z.string().optional(),
    subgraphConfigs: z.array(subgraphConfigSchema),
});
export const liveCustomerDataApiConfigSchema = customerDataApiConfigSchema.extend({
    id: z.string().min(1, 'ID is required'),
    subgraphConfigs: z.array(servedSubgraphConfigSchema),
});
//# sourceMappingURL=CustomerDataApiConfig.js.map